<div class="container">
  <!--Instructions container-->
  <div class="row">
    <div class="col-12">
      <h3>{{ "accounts.create_barcode.title" | translate }}</h3>
      <form #formCreateBarcode="ngForm" (ngSubmit)="formCreateBarcode.valid && onSubmit(formCreateBarcode)" novalidate>
        <p>{{ "accounts.create_barcode.instructions" | translate }}</p>

        <div class="row">
          <div class="col-12 col-md-6">
            <div class="form-group">
              <label>{{ "accounts.create_barcode.amount" | translate }}</label>
              <input type="number" class="form-control" name="amount" [(ngModel)]="barcode.amount" #amount="ngModel" [ngClass]="inputFieldCss(amount, formCreateBarcode)" positiveNumber barcodeMinimumAmount="{{this.configuration.minGreendotCashLoads}}" barcodeMaximumAmount="{{this.configuration.maxGreendotCashLoads}}" required>
              <app-field-error-display [control]="amount" [form]="formCreateBarcode"></app-field-error-display>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-md-6">
            <div class="form-group">
              <label for="selectedRetailer">{{ "accounts.create_barcode.retailer" | translate }}</label>
              <select class="form-control custom-select" [(ngModel)]="barcode.retailer" name="selectedRetailer" id="selectedRetailer">
                <option [ngValue]="null">{{ "accounts.create_barcode.choose" | translate }}</option>
                <option *ngFor="let selectedRetailer of retailers" [ngValue]="selectedRetailer" >{{selectedRetailer.description}}</option>
              </select>
            </div>
          </div>
        </div>

        <!--CODIGO DE OPCIÓN DE TARJETA-->
        <div class="col-12">
          <div class="mt-2">
            <div class="form-check form-check-inline">
              <input
                class="form-check-input"
                type="radio"
                name="inlineRadioOptions"
                id="yes"
                [value]="true"
                [(ngModel)]="isOwner"
              >
              <label class="form-check-label" for="yes">{{"accounts.create_barcode.option1" | translate}}</label>
            </div>
            <div class="form-check form-check-inline">
              <input
                class="form-check-input"
                type="radio"
                name="inlineRadioOptions"
                id="no"
                [value]="false"
                [(ngModel)]="isOwner"
              >
              <label class="form-check-label" for="no" [innerHTML]="'accounts.create_barcode.option2' | translate: {program: productName}"></label>
            </div>
          </div>
        </div>

        <!--Condición en caso de que sea tarjeta de tercero -->
        <div class="mt-3" *ngIf="!isOwner">
          <div class="row">
            <div class="col-md-6">
              <label>{{"accounts.create_barcode.card_number" | translate}}</label>
              <div class="input-group">
                <input (input)="onInputChange($event)" type="tel" mask="0000 0000 0000 0000" class="form-control" name="targetCard" [(ngModel)]="barcode.targetReference" #targetReference="ngModel" [ngClass]="inputFieldCss(targetReference, formCreateBarcode)" required>
                <button class="btn btn-primary border-right" type="button" (click)="verifyThirdParty(barcode.targetReference);"><i class="fas fa-search"></i>&nbsp;{{"accounts.create_barcode.validate" | translate}}</button>
              </div>
              <app-field-error-display [control]="targetReference" [form]="formCreateBarcode"></app-field-error-display>
            </div>
          </div>
          <div>
          </div>
        </div>

        <div class="mt-3" *ngIf="showThirdPartyInfo">
          <p-card>
            <div class="d-flex flex-column justify-content-center align-items-center">
              <h5>{{"accounts.create_barcode.account-info" | translate}}</h5>
              <hr style="border: 1px solid black; width: 100%;">
              <p><b>{{"accounts.create_barcode.account-message" | translate}}</b></p>
              <p>{{ barcode.targetReference | mask : '0000 0000 0000 0000'}}</p>
              <p><b>{{"accounts.create_barcode.card-holder" | translate}}</b></p>
              <p>{{ thirdPartyName }}</p>
            </div>
          </p-card>
        </div>

        <button *ngIf="isOwner" [disabled]="!formCreateBarcode.form.valid || barcode.amount < 20" class="btn btn-primary mb-4 pr-5 pl-5 mt-3 float-right" type="submit">
          {{"accounts.create_barcode.create" | translate}}
        </button>
        <button *ngIf="!isOwner" [disabled]="!formCreateBarcode.form.valid || barcode.amount < 20 || !enableCreateThirdPartyBtn" class="btn btn-primary mb-4 mt-3 pr-5 pl-5 float-right" type="submit">
          {{"accounts.create_barcode.create" | translate}}
        </button>
      </form>
    </div>
  </div>

</div>

<!-- Modal to create barcode -->
<ng-template #modalContent let-modal>
  <div class="modal-header">
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body text-center">
    <div class="modal-title text-center">
      <h4 [innerHTML]="'accounts.greenDot-barcode.use-only' | translate: { retailer: createdCode.retailer.name }"></h4>
      <h3>{{"accounts.greenDot-barcode.how-much" | translate}}</h3>
      <h1><strong>{{createdCode.amount | currency:'$':'symbol':'1.2':'en'}}</strong></h1>
    </div>
  </div>

  <div class="text-center">
    <app-bar-codes-custom [barcodeValue]="createdCode.id"></app-bar-codes-custom>

    <h4 class="text-success">{{"accounts.greenDot-barcode.deposit" | translate}}</h4>
    <img src="assets/logos/greenDot_logo.png" class="text-center" width="120" alt="">
  </div>

  <div class="alert alert-info text-center mt-3">
    <p style="margin-bottom: 0" [innerHTML]="'accounts.greenDot-barcode.instructions' | translate: { amount: createdCode.amount | currency:'$':'symbol':'1.2':'en' }"></p>
  </div>

  <div class="ml-4">
    <p class="text-left" [innerHTML]="'accounts.greenDot-barcode.retailer' | translate:{ retailer: createdCode.retailer.name }" ></p>
    <p class="text-left" [innerHTML]="'accounts.greenDot-barcode.expiration' | translate:{ date: createdCode.expirationDate | date:'MM-dd-yyyy HH:mm:ss ': 'utc' }" ></p>
    <p>{{ "accounts.new_code.find_closer" | translate: {retailer: createdCode.retailer.name} }}<a href='https://www.google.com.mx/maps/search/{{createdCode.retailer.name}}/' target="_blank" class="d-inline"><b>{{"accounts.new-code.click-here" | translate}}</b></a></p>
  </div>
</ng-template>

<!--Dialog to make look up-->
<p-dialog header=" " [(visible)]="verifyData" [modal]="true" [baseZIndex]="10000" style="padding: 0 !important;">
  <div class="d-flex flex-column align-items-center justify-content-center">
    <i class="fas fa-exclamation-circle fa-2x notification-circle-icon"></i>
    <p>{{ "accounts.transfers.notification-card" | translate }}</p>
    <p><b>{{ "accounts.transfers.notification-holder" | translate: {holder: thirdPartyName } }}</b></p>

  </div>
  <div class="d-flex justify-content-between">
    <button type="button" class="btn btn-outline-primary btn-yesno-width" (click)="verifyData = false">{{ "accounts.target_account.no" | translate}}</button>
    <button type="button" class="btn btn-outline-success ml-3 btn-yesno-width" (click)="confirmTargetBarcode();">{{ "accounts.target_account.yes" | translate}}</button>
  </div>
</p-dialog>

<!--Dialog to notify invalid code-->
<p-dialog header="{{ 'accounts.create_barcode.invalid-card-number-title' | translate }} " [(visible)]="displayInvalidThirdAccount" [modal]="true" [baseZIndex]="10000">
  <div class="d-flex align-items-center justify-content-center flex-column">
    <p>{{ "accounts.create_barcode.invalid-card-number" | translate}}</p>
  </div>
  <div class="d-flex justify-content-center">
    <button type="button" class="btn btn-outline-primary btn-width"  (click)="displayInvalidThirdAccount = false">{{ "accounts.create_barcode.close" | translate}}</button>
  </div>
</p-dialog>



